import { gql } from '@apollo/client';

export const GET_PLACES = gql`
  query GetPlaces($search: String) {
    places(search: $search) {
      id
      name
      corporateName
      phone
      document
      internalId
      email
      active
    }
  }
`;

export const GET_ACTIVE_PLACES = gql`
  query GetActivePlaces {
    activePlaces {
      id
      name
      corporateName
      internalId
      active
    }
  }
`;

export const SEARCH_PLACES = gql`
  query SearchPlaces($query: String!) {
    searchPlaces(query: $query) {
      id
      name
      corporateName
      phone
      document
      internalId
      email
      active
    }
  }
`; 